import { combineReducers } from "redux";
import AccountReducer, { IAccountReducerState } from "./account.reducer";
import TableReducer, {ITableReducerState} from "./table.reducers";
import staticDataReducer, {IStaticDataReducerState} from "./staticData.reducer";
import {IFacility} from "../../shared/models/facility.model";
import facilityReducer from "./facilityAndLocation.reducer";
import {ILocation} from "../../shared/models/location.model";
import headerReducer, {IHeaderReducerState} from "./header.reducer";
import StateManagementReducer, {IStateManagementState} from "./stateManagement.reducer";
import {ISelectedLabReducerState} from "./selectedLab.reducer";
import SelectedLabReducer from "./selectedLab.reducer";
export interface IRootReducerState {
    account: IAccountReducerState,
    table: ITableReducerState,
    staticData: IStaticDataReducerState,
    facilityDetails: IFacility,
    locationDetails: ILocation,
    stateManagement: IStateManagementState,
    header: IHeaderReducerState,
    selectedLab: ISelectedLabReducerState,

}

const rootReducer = combineReducers({
    account: AccountReducer,
    table: TableReducer,
    staticData: staticDataReducer,
    facilityAndLocationDetails:facilityReducer,
    header:headerReducer,
    stateManagement: StateManagementReducer,
    selectedLab: SelectedLabReducer
});

export default rootReducer;
